import { CanActivateFn } from '@angular/router';

import * as fromGenerated from '../../_generated';
import { authRoleGuard } from '../../auth/auth-role.guard';

/**
 * An affordance, not the control (constitution Article II):
 * the API's class-level @AuthRoles(UserRole.super_admin) on admin-managed-skills
 * is. A named constant so the route spec can find it by identity.
 */
export const adminManagedSkillsCanActivateGuard: CanActivateFn = authRoleGuard([
  fromGenerated.UserRole.super_admin,
]);
